var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-header"},[_c('h2',[_vm._t("default",function(){return [_vm._v("Dashboard")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }